import React from 'react'
import { Box } from '@mui/material'

interface Props {
  variant: 'paper'
  children?: React.ReactNode
}

const AccordionItemContent: React.FC<Props> = ({ children, variant }) => {
  if (variant === 'paper') return <Box sx={{ pl: 3, pr: 3 }}>{children}</Box>
  return <Box>{children}</Box>
}

export default AccordionItemContent
